export enum UserInfoSentType {
    BasicInfo = 1,
    Addresses,
    Checkout
}